// Credentialed profile deletion (COPPA §312.6, Tier 2): lets a parent delete a
// SAVED racer from any device using its handle + recovery word — no account or
// email needed. Lives on the /privacy page. For racers that were never saved,
// deletion is done in-app on the device (Profile page) or by emailing us.
import { useState } from "react";
import { deleteProfile } from "../lib/api";

export default function DeleteRacerForm() {
  const [handle, setHandle] = useState("");
  const [passphrase, setPassphrase] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  async function submit() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await deleteProfile({ handle: handle.trim(), passphrase });
      setDone(true);
    } catch (e) {
      setErr(
        e instanceof Error
          ? e.message
          : "Couldn't delete that — check the details and try again.",
      );
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <p className="text-sm font-semibold text-ink/70">
        ✓ Deleted. That racer's profile, scores, and badges have been removed from
        our servers.
      </p>
    );
  }

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      <input
        type="text"
        value={handle}
        placeholder="handle"
        autoComplete="off"
        onChange={(e) => setHandle(e.target.value)}
        className="rounded-2xl border-[3px] border-ink bg-white px-3 py-2.5 font-semibold text-ink outline-none placeholder:text-ink/30 focus:border-flame"
      />
      <input
        type="text"
        value={passphrase}
        placeholder="recovery word"
        autoComplete="off"
        onChange={(e) => setPassphrase(e.target.value)}
        className="rounded-2xl border-[3px] border-ink bg-white px-3 py-2.5 font-semibold text-ink outline-none placeholder:text-ink/30 focus:border-flame"
      />
      <button
        type="button"
        className="btn-chunk bg-flame py-2.5 text-white disabled:opacity-50 sm:col-span-2"
        disabled={busy || !handle.trim() || !passphrase}
        onClick={submit}
      >
        {busy ? "Deleting…" : "🗑 Delete this saved racer"}
      </button>
      {err && (
        <p className="text-xs font-bold text-flame sm:col-span-2">{err}</p>
      )}
    </div>
  );
}
